export default __webpack_public_path__ + "static/media/Savior's Mace.88c0007e.jpg";